// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__vrsaL","upload":"Small_upload__22BCs","imageWrap":"Small_imageWrap__CA8fJ","removeBtn":"Small_removeBtn__1S1Ru"};